import { useState } from "react";
import DivStyle from "../../../components/style/div.component";
import CheckTable from "../../../components/table/CheckTable";
import ButtonStyle from "../../../components/style/button.component";
import InputFormStyle from "../../../components/style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import GAMEAPI from "../../../api/game";
interface SenderUSerProps {
  setSenderUserId: (value: any) => void;
  setSenderUserNickname: (value: any) => void;
  setIsOpen: (value: any) => void;
}

const SearchSenderUser = (props: SenderUSerProps) => {
  const [selected, setSelected] = useState("");
  const [dataList, setDataList] = useState<any[]>([]);
  const { setSenderUserId, setSenderUserNickname, setIsOpen } = props;
  const [search, setSearch] = useState("");
  const headers = [
    {
      text: "id",
      align: "center",
      value: "userId",
      sortable: false,
    },
    {
      text: "닉네임",
      align: "center",
      value: "nickname",
      sortable: false,
    },
  ];

  const getSearchData = async () => {
    const response = await GAMEAPI.getGameUserList(0, 200, search);

    if (response.data.result === 1) {
      const userData = response.data.users;
      setDataList(userData);
    }
  };

  const setData = async () => {
    if (dataList.length > 0 && selected !== "") {
      const data = dataList[parseInt(selected)];

      setSenderUserId(data["userId"]);
      setSenderUserNickname(data["nickname"]);
      setIsOpen(false);
    } else {
      alert("선택해주세요.");
    }
  };

  return (
    <DivStyle
      style={{
        maxWidth: "500px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        minWidth: "300px",
      }}
      borderRadius="10px"
      position="fixed"
      width="90%"
      height="auto"
      backgroundColor="black"
      color="white"
      display="flex"
      flex_direction="column"
      align_items="center"
    >
      <h4>송신 유저 검색</h4>
      <DivStyle
        width="80%"
        display="flex"
        flex_direction="row"
        align_items="center"
      >
        <InputFormStyle
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              getSearchData();
            }
          }}
        ></InputFormStyle>
        <div onClick={() => getSearchData()}>
          <Icon path={mdiMagnify} size={1} />
        </div>
      </DivStyle>
      <CheckTable
        selected={selected}
        setSelected={setSelected}
        headers={headers}
        dataList={dataList}
      />
      <DivStyle
        display="flex"
        flex_direction="row"
        width="auto"
        marginTop="30px"
        marginBottom="30px"
      >
        <ButtonStyle
          color="white"
          border="none"
          borderRadius="5px"
          width="100px"
          height="40px"
          marginRight="5px"
          backgroundColor="#1976D2"
          onClick={() => setData()}
        >
          적용
        </ButtonStyle>
        <ButtonStyle
          color="white"
          backgroundColor="#757575"
          border="none"
          borderRadius="5px"
          width="100px"
          height="40px"
          marginLeft="5px"
          onClick={() => setIsOpen(false)}
        >
          닫기
        </ButtonStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default SearchSenderUser;
